import { LinkButton } from "@digipost/dds-buttons-react";
import { useLanguage } from "@digipost/translate";
import { FC, useCallback, useEffect } from "react";

import { DigipostEntryPoint } from "../../../types/entrypoint";
import {
  SiteImproveActions,
  SiteImproveCategories,
  siteImproveEvent,
} from "../analytics/siteimprove";
import { useEntrypointContext } from "../EntrypointContext";
import Translated from "../infrastructure/components/Translated";
import { useRootPath } from "../infrastructure/hooks/useRootPath";
import { findUriIfExists } from "../infrastructure/link";
import styles from "./OAuth.module.less";
import { useTokenParam } from "./oauth-utils";
import SpinnerContainer from "./spinnerContainer/SpinnerContainer";

export const OAuthSignicat: FC = () => {
  const entrypoint: DigipostEntryPoint = useEntrypointContext();
  const { language } = useLanguage();
  const rootPath = useRootPath();
  const token = useTokenParam();

  const doLogin = useCallback(async () => {
    const idpAuthUrl = findUriIfExists("login_idp", entrypoint.link);

    const returnUrl = `${rootPath}/mobileSuccessWithIDportenLogout/${token}`;
    const returnUrlError = `${rootPath}/loginError`;

    const idpSecurityLevel = "HIGH";

    window.location.href =
      idpAuthUrl +
      `?prompt=login&provider=signicat&eidasLoa=${idpSecurityLevel}&rolle=PRIVAT&returnUrl=${returnUrl}&returnUrlError=${returnUrlError}&lang=${language}`;
  }, [entrypoint, token]);

  useEffect(() => {
    doLogin();
  }, [doLogin]);

  return (
    <SpinnerContainer>
      <LinkButton
        className={styles.loginLink}
        onClick={() => {
          siteImproveEvent({
            action: SiteImproveActions.LOGIN_WITH_SIGNICAT,
            category: SiteImproveCategories.LOGIN_PRIVATE_USER,
            label: "knapp for å logge inn i Digipost",
          });
          doLogin();
        }}
      >
        <Translated textKey={"oauth.if_no_redirect"} />
      </LinkButton>
    </SpinnerContainer>
  );
};
